import React from "react";
import BarChartTalents from "../Charts/BarChartTalents";

export default function DominantFrequency(props) {
  let {
    getAssessmentDimensionsV3Data,
    EditButtonFn,
    managerName,
    loading

  } = props;


  let AssessmentList = []
  if (getAssessmentDimensionsV3Data && getAssessmentDimensionsV3Data.length > 0) {
    getAssessmentDimensionsV3Data.forEach((element) => {
      AssessmentList.push({
        ...element,
        finalSum: (Number(element.count) * Number(element.rankSum))
      })
    })
    AssessmentList.sort((a,b) => (a.finalSum - b.finalSum))
  }

  console.log("AssessmentList--1->", AssessmentList)


  return (
    <>

      <main className="p-10 px-6 space-y-6 bg-white page-break">
        <div className="page-break">
          <div className="flex items-center justify-between w-full py-4 border-b">
            <h1 className="text-lg font-semibold"> {EditButtonFn("TalentAssessmentReport", "Team TalentPlusStrengths Assessment Report")}</h1>
            <p className="text-lg font-semibold">
              {managerName}
            </p>
          </div>

          <div className='py-2 space-y-4'>
            <h1 className="text-3xl text-[#212121] pt-2">
              Dominant Theme Frequency
            </h1>
            <h1 className='text-xl font-medium text-[#212121]'>Teams's Dominant Theme Frequency</h1>
            
            <BarChartTalents
              list={AssessmentList}
            />

            {!(AssessmentList && AssessmentList.length > 0) ?
              <>
                {!loading ?
                  <div className="py-24 text-center text-xl text-[#3d405B]/70">No Data Available</div>
                  : null}
              </>
              : null}


          </div>
        </div>
      </main>

    </>
  );
}
